import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { SiparisEditComponent } from './siparis-edit.component';
import { SiparisKartComponent } from './siparis-kart.component';
import { SiparisKartSadeComponent } from './siparis-kart-sade.component';

@DinamikBilesen({
  id: 'siparis',
  baslik: 'Sipariş',
  aciklama: 'Sipariş kaydı',
  ikon: 'shopping-cart',
  kategori: 'satis',
})
class Siparis {
  paylas_kutusu = SiparisEditComponent;
  paylasilmis_kart = SiparisKartComponent;
  paylasilmis_kart_sade = SiparisKartSadeComponent;
  hesaplamalar = {
    pipeline: [
      { $match: { _uid: '{{kartId}}', silindi: { $ne: true } } },
      { $lookup: { from: 'hareketler', localField: 'veri.icerikler', foreignField: '_id', as: 'icerikDetay' } },
      { $unwind: { path: '$icerikDetay', preserveNullAndEmptyArrays: false } },
      { $group: {
        _id: null,
        toplam: { $sum: 1 },
        toplamTutar: { $sum: { $multiply: [{ $ifNull: ['$icerikDetay.ek.miktar', 0] }, { $ifNull: ['$icerikDetay.ek.birimFiyat', 0] }] } },
        toplamMiktar: { $sum: { $ifNull: ['$icerikDetay.ek.miktar', 0] } }
      }}
    ]
  };
}
